import { createSvgIcon } from "./create-svg-icon";

export const ArrowBack = createSvgIcon(
  <svg viewBox="0 -4 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.75 4.50064C17.75 4.2245 17.4702 4.00064 17.125 4.00064H2.38377L6.31752 0.854643C6.47561 0.728171 6.53735 0.543834 6.47949 0.37107C6.42162 0.198306 6.25294 0.063362 6.03698 0.01707C5.82103 -0.029222 5.59061 0.020171 5.43252 0.146643L0.432519 4.14664C0.314966 4.24045 0.248901 4.36782 0.248901 4.50064C0.248901 4.63347 0.314966 4.76084 0.432519 4.85464L5.43252 8.85464C5.59061 8.98112 5.82103 9.03051 6.03698 8.98422C6.25294 8.93792 6.42162 8.80298 6.47949 8.63022C6.53735 8.45745 6.47561 8.27312 6.31752 8.14664L2.38377 5.00064H17.125C17.4702 5.00064 17.75 4.77679 17.75 4.50064Z"
      fill="currentColor"
    />
  </svg>,
);
